<template>
    <div class="index">
        <div class="search-wrap flex">
            <a @click="goSearch" class="search-link"
                >输入股票代码/首字母查询个股详情</a
            >
            <a class="link-btn" @click="goHome">全市场</a>
        </div>
        <section class="mod mod2">
            <dl class="mod-top">
                <dt>{{ name }}</dt>
            </dl>
            <div class="chart-info flex">
                <div>
                    持仓股票<strong :class="chicData.holdstk | formateRedGreen"
                        >{{ chicData.holdstk }}只</strong
                    >
                </div>
                <div>
                    持仓市值<strong
                        :class="chicData.holdamt | formateRedGreen"
                        >{{
                            chicData.holdamt
                                | num(["元", "万", "亿", "万亿"], "元")
                        }}</strong
                    >
                </div>
                <div>
                    较上期<strong :class="chicData.addamt | formateRedGreen">{{
                        chicData.addamt | num(["元", "万", "亿", "万亿"], "元")
                    }}</strong>
                </div>
            </div>
            <div style="text-align: right">数据日期 : {{ chicData.time }}</div>
        </section>
        <section class="mod">
            <h2 class="mod-tit">持仓市值</h2>
            <div class="chart chart-hold" id="lineJiGou"></div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit-block">持仓偏好</h2>
            <div class="table-scroll table-organization">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>行业名称</th>
                        <th>占比</th>
                        <th>股票数</th>
                        <th>持股市值</th>
                    </tr>
                    <tr v-for="item in jiGouPrefer" :key="item.id">
                        <td>
                            <div class="name-s">{{ item.bkmc }}</div>
                        </td>
                        <td>{{ (item.holdratio * 100).toFixed(2) }}%</td>
                        <td>{{ item.holdstk }}</td>
                        <td>
                            {{
                                item.holdamt
                                    | num(["元", "万", "亿", "万亿"], "元")
                            }}
                        </td>
                    </tr>
                </table>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit-block">
                持股明细
                <div class="fr link-more" @click="goMore">查看更多</div>
            </h2>
            <!-- <div class="nav2">
        <div class="nav2-wrap flex">
          <span v-for="(nav,i) in subNavs" :key="i" :class="curSubNav==i?'cur':''" @click="checkJiGouDetail(i)">{{nav}}</span>
        </div>
      </div> -->
            <div class="table-scroll table-scroll-h">
                <div class="table-l fl">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>名称代码</th>
                        </tr>
                        <tr
                            v-for="item in stockList.slice(0, 10)"
                            :key="item.id"
                            @click="goToJgChartDetail(item.stockcode)"
                        >
                            <td>
                                {{ item.sesname
                                }}<small>{{ item.stockcode }}</small>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="table-r">
                    <div class="table-r-wrap table-r-wrap3">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>持仓市值</th>
                                <th>持仓量</th>
                                <th>持仓占比</th>
                                <th>所属板块</th>
                            </tr>
                            <tr
                                v-for="item in stockList.slice(0, 10)"
                                :key="item.id"
                                @click="goToJgChartDetail(item.stockcode)"
                            >
                                <td>
                                    {{
                                        item.holdamt
                                            | num(
                                                ["元", "万", "亿", "万亿"],
                                                "元"
                                            )
                                    }}
                                </td>
                                <td>
                                    {{
                                        item.holdvol
                                            | num(["", "万", "亿", "万亿"], "")
                                    }}
                                </td>
                                <td :class="item.holdratio | formateRedGreen">
                                    {{ (item.holdratio * 100).toFixed(2) }}%
                                </td>
                                <td>{{ item.bkmc }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {
    jiGouHolderl,
    jiGouPrefer,
    jiGouDetail,
    getYunSpj,
} from "@/api/xqDetail.js";
import { getUrlQuery } from "@/utils/handleUrl.js";

import { share } from "@/lib/dzh";
import wxshare from "@/assets/js/wxshare";

export default {
    name: "jgDetail",
    components: {},
    data() {
        return {
            name: "",
            curSubNav: 0,
            stockCode: "", // 股票代码
            userToken: "", // 用户token
            version: "", // 客户端版本号
            type: "", // 手机类型
            chicData: {
                holdstk: "",
                holdamt: "",
                addamt: "",
                time: "",
            }, //持仓概览数据
            jiGouPrefer: [], //持仓偏好数据
            subNavs: ["全部", "昨日新建", "昨日增持", "昨日减持"],
            stockList: [],
            jiGouDetailShow: false,
        };
    },
    filters: {
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        num(num, arr, type) {
            if (!num && num !== 0) {
                return "";
            } else {
                let str = Number(num);
                if (num > 0) {
                    let param = {};
                    let k = 10000;
                    let sizes = arr;
                    let i;
                    if (num < k) {
                        param.value = num;
                        param.unit = type;
                    } else {
                        i = Math.floor(Math.log(num) / Math.log(k));
                        param.value = (num / Math.pow(k, i)).toFixed(2);
                        param.unit = sizes[i];
                    }
                    return (
                        parseFloat(param.value.toString()).toFixed(2) +
                        param.unit
                    );
                } else if (num < 0) {
                    let param = {};
                    let k = 10000;
                    let sizes = arr;
                    let i;
                    num = -num;
                    if (num < k) {
                        param.value = -num;
                        param.unit = type;
                    } else {
                        i = Math.floor(Math.log(num) / Math.log(k));
                        param.value = -(num / Math.pow(k, i)).toFixed(2);
                        param.unit = sizes[i];
                    }
                    return (
                        parseFloat(param.value.toString()).toFixed(2) +
                        param.unit
                    );
                } else if (num === 0) {
                    return 0.0;
                }
                return parseFloat(str).toFixed(2);
            }
        },
    },
    created() {
        this.stockCode = getUrlQuery("code");
        this.userToken = getUrlQuery("token");
        this.version = getUrlQuery("version");
        this.name = decodeURIComponent(getUrlQuery("name"));
        let u = navigator.userAgent;
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        if (isiOS) {
            this.type = "ios";
        } else if (isAndroid) {
            this.type = "android";
        }
        wxshare.do(
            this.$route.fullPath,
            "http://static.yundzh.com/logo.png",
            "沪深港通"
        );
    },
    mounted: function () {
        this.getJiGouHolderl();
        this.getJiGouPrefer();
        this.getJiGouDetail();
        document.title = "沪深港通";
        share("沪深港通", this.$route.fullPath);
    },
    methods: {
        // 跳转到搜索页
        goSearch: function () {
            this.$router.push("/search");
        },
        // 跳转到首页
        goHome: function () {
            this.$router.push("/");
        },
        // 获取持仓概览
        getJiGouHolderl: function () {
            let that = this;
            let obj = {
                token: that.userToken,
                httpdzh: that.version
                    ? "dzh-" + that.type + "-" + that.version
                    : "",
                particode: that.stockCode,
            };
            jiGouHolderl(obj).then((res) => {
                if (res.data.err === 0) {
                    that.chicData = {
                        holdstk: res.data.data.holdstk,
                        holdamt: res.data.data.holdamt,
                        addamt: res.data.data.addamt,
                        time: res.data.data.time,
                    };
                    that.getYunSpj(res.data.data.datas);
                }
            });
        },
        // 获取机构持仓市值模块上证指数数据
        getYunSpj: function (list) {
            getYunSpj({ begin_time: list[list.length - 1].tradedate }).then(
                (res) => {
                    let data = res.data.data;
                    let showData = [];
                    list.forEach((item) => {
                        data.forEach((items) => {
                            if (item.tradedate === items[0]) {
                                showData.unshift(items);
                            }
                        });
                    });
                    let arr = showData.map((item) => {
                        return item[1];
                    });
                    this.disposeLineData(list, arr);
                }
            );
        },
        // 处理图表数据
        disposeLineData: function (list, arr) {
            let tiemData = [];
            let holdamtData = [];
            list.forEach((item) => {
                let str =
                    item.tradedate.substr(0, 4) +
                    "-" +
                    item.tradedate.substr(4, 2) +
                    "-" +
                    item.tradedate.substr(6, 2);
                tiemData.unshift(str);
                holdamtData.unshift((item.holdamt / 100000000).toFixed(2));
            });
            this.drawLine(tiemData, holdamtData, arr);
        },
        // 获取机构持仓偏好
        getJiGouPrefer: function () {
            let that = this;
            let obj = {
                token: that.userToken,
                httpdzh: that.version
                    ? "dzh-" + that.type + "-" + that.version
                    : "",
                particode: that.stockCode,
            };
            jiGouPrefer(obj).then((res) => {
                if (res.data.err === 0) {
                    that.jiGouPrefer = res.data.data;
                }
            });
        },
        // 持股明细
        getJiGouDetail: function () {
            let that = this;
            that.jiGouDetailShow = true;
            let obj = {
                token: that.userToken,
                httpdzh: that.version
                    ? "dzh-" + that.type + "-" + that.version
                    : "",
                particode: that.stockCode,
                holdtype: that.curSubNav,
            };
            jiGouDetail(obj).then((res) => {
                that.jiGouDetailShow = false;
                if (res.data.err === 0) {
                    that.stockList = res.data.data.list;
                }
            });
        },
        // 持股明细切换
        checkJiGouDetail: function (i) {
            if (this.jiGouDetailShow) return;
            this.curSubNav = i;
            this.$nextTick(() => {
                this.getJiGouDetail();
            });
        },

        drawLine: function (tiemData, holdamtData, arr) {
            var chartDom = document.getElementById("lineJiGou");
            var myChart = this.$echarts.init(chartDom);
            var option;
            option = {
                color: ["#F06F6F", "#7EB2F3"],
                tooltip: {
                    trigger: "axis",
                    confine: true,
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 35,
                    top: 10,
                    containLabel: true,
                },
                legend: {
                    type: "plain",
                    bottom: 0,
                    left: 0,
                    icon: "roundRect",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 30,
                    selectedMode: false,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: tiemData,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    axisLabel: {
                        color: "#999",
                        show: true,
                        interval: 1000000000000000000000000,
                        showMinLabel: true,
                        showMaxLabel: true,
                        formatter: function (value) {
                            //文本格式化
                            if (value === tiemData[0]) {
                                return "{right|" + value + "}";
                            } else if (
                                value === tiemData[tiemData.length - 1]
                            ) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                                padding: [0, 0, 0, 50],
                            },
                            left: {
                                width: 50,
                                fontSize: 10,
                                align: "right",
                                padding: [0, 50, 0, 0],
                            },
                            center: {
                                fontSize: 10,
                                align: "left",
                            },
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        nameGap: 17,
                        nameTextStyle: {
                            color: "#999",
                            align: "left",
                        },
                        type: "value",
                        scale: true, //自动适配y轴，不需要必须从0开始 或者选择下边这种设置最大最小值
                        splitNumber: 5,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}",
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#C8C8C8",
                            },
                        },
                    },
                    //   {
                    //     nameGap:17,
                    //     nameTextStyle:{
                    //       color:'#999',
                    //       align:'right',
                    //     },
                    //     type: 'value',
                    //     alignTicks: true,
                    //     position :'right',
                    //     axisLabel:{
                    //       fontSize:10,
                    //       color:'#999',
                    //       inside:true,
                    //       verticalAlign:'bottom',
                    //       margin:3,
                    //       padding:[1,0],
                    //       formatter:'{value}'
                    //     },
                    //     splitLine:{ show:false }
                    //   }
                ],
                series: [
                    //   {
                    //     name: '上证指数',
                    //     type: 'line',
                    //     // stack: 'Total',
                    //     symbol:'none',
                    //     data: arr,
                    //   },
                    {
                        name: "持仓市值（亿）",
                        type: "line",
                        // stack: 'Total',
                        // yAxisIndex:1,
                        symbol: "none",
                        data: holdamtData,
                    },
                ],
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        goMore: function () {
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/jgmore?code=" +
                this.stockCode +
                "&DZHSPECIAL=265&name=" +
                this.name;
            // location.href='/index.html#/jgmore?code='+this.stockCode+'&DZHSPECIAL=265'
            // url('/jgmore',{code:this.stockCode},265)
        },

        /**
         * 调转到 持股明细详情
         * @param {string} stockcode 股票代码
         * 这和 this.stockCode 是两个不同的值，分别代表不同意思。
         * 持股明细详情 路由是：/jgchartdetail/?code={$particode}&stockCode={$stockcode}&name={compname}
         * @author zhangrongzong@gw.com.cn
         */
        goToJgChartDetail: function (stockcode) {
            let that = this;
            if (stockcode == null || stockcode == "") {
                return;
            }
            if (that.stockCode == null || that.stockCode == "") {
                return;
            }
            let paramsStr =
                "#/jgchartdetail?code=" +
                that.stockCode +
                "&stockCode=" +
                stockcode +
                "&name=" +
                that.name;
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                paramsStr;
        },
    },
};
</script>
